import React, { useEffect, useState } from 'react';
import Hero from './Hero';
import Testimonials from './Testimonials';
import Features from './Features';
import FAQ from './FAQ';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Home = ({ auth }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth && auth.authenticated) {
      navigate('/encyklopedia');
    } else {
      setLoading(false);
    }
  }, [auth, navigate]);

  if (loading) {
    return null;
  }

  return (
    <>
      <Hero />
      <Testimonials />
      <Features />
{/*       <FAQ /> */}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Home);